import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-unauthorized-layout',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './unauthorized-layout.html',
  styleUrls: ['./unauthorized-layout.scss']
})
export class UnauthorizedLayoutComponent implements OnInit {
  currentLanguage: 'en' | 'ar' = 'en';
  currentDirection: 'ltr' | 'rtl' = 'ltr';

  constructor(
    private translate: TranslateService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Initialize language from localStorage or default to 'en'
    const savedLanguage = localStorage.getItem('language') as 'en' | 'ar' | null;
    this.currentLanguage = savedLanguage ? savedLanguage : 'en';
    this.currentDirection = this.currentLanguage === 'ar' ? 'rtl' : 'ltr';
    
    // Apply language to TranslateService
    this.translate.use(this.currentLanguage);
    document.documentElement.lang = this.currentLanguage;
    document.documentElement.dir = this.currentDirection;
  }

  toggleLanguage(): void {
    this.currentLanguage = this.currentLanguage === 'en' ? 'ar' : 'en';
    this.currentDirection = this.currentLanguage === 'ar' ? 'rtl' : 'ltr';
    this.translate.use(this.currentLanguage);
    localStorage.setItem('language', this.currentLanguage);
    document.documentElement.lang = this.currentLanguage;
    document.documentElement.dir = this.currentDirection;
  }
}
